import { ConditionalPartial } from '../../../../utils';

import { CreateHcLotReleaseConfigRequestDto } from './create-hc-lot-release-config.request.dto';

/**
 * DTO for updating HC lot release configuration
 * All fields are optional for partial updates
 */
export class UpdateHcLotReleaseConfigRequestDto extends ConditionalPartial(CreateHcLotReleaseConfigRequestDto) {}
